/**
 * Placeholders Module
 *
 * Generates placeholder text for booking engine inputs
 */

import { reverse_date } from "@utilities";

/**
 * Generate occupancy placeholder text
 */
export function get_occupancy_placeholder(occupancy) {
  if (occupancy[0].adults == 0) return "Quanti ospiti?";

  let placeholder =
    occupancy[0].adults +
    " adult" +
    (occupancy[0].adults == 1 ? "o" : "i");

  if (occupancy[0].children.length)
    placeholder +=
      ", " +
      occupancy[0].children.length +
      " bambin" +
      (occupancy[0].children.length == 1 ? "o" : "i");

  return placeholder;
}

/**
 * Generate autocomplete placeholder text
 */
export function get_autocomplete_placeholder(autocomplete_focus, keydsmap, location) {
  let default_placeholder = "Destinazione";
  if (autocomplete_focus) return default_placeholder;
  if (keydsmap.length == 0) return default_placeholder;
  return location.label
    ? location.label.charAt(0).toUpperCase() +
        location.label.slice(1).toLowerCase()
    : default_placeholder;
}

/**
 * Generate airports placeholder text
 */
export function get_airports_placeholder(departure_airports) {
  if (departure_airports.filter(a => a.selected).length == 0)
    return "Aeroporto";

  let placeholder = departure_airports
    .map((a) => {
      if (a.selected)
        return (
          a.name.charAt(0).toUpperCase() + a.name.slice(1).toLowerCase()
        );
    })
    .filter((n) => n) //remove empty elements (a.selected == false)
    .join(", ");

  return placeholder;
}

/**
 * Generate availabilities placeholder text
 */
export function get_availabilities_placeholder(departure_date) {
  if (departure_date == "") return "Quando";
  return reverse_date(departure_date).replaceAll("-", "/");
}
